import React, { Component } from 'react';
import styler from 'react-styling';
import Relay from 'react-relay';

import ContactAvatar from './ContactAvatar';

import { filterNotNullEdgeNodes } from '../libs/Extract';

const style = styler `
  Wrapper
    overflow: auto
    height: 52px
    margin-top: 52px
    padding: 0 25px 0 20px
    margin-left: -40px
    margin-right: -40px
    background: rgba(255, 255, 255, 0.5)
  Resources
    overflow: auto
    position: absolute
    height: calc(100% - 169px)
    width: calc(100% - 80px)
    padding: 40px 0
  NumberUnits
    font-size: 14px
    float: left
    color: #333
    position: relative
    top: 50%
    transform: translateY(-50%)
  Clear
    float: right
    text-align: right
    color: #333
    cursor: pointer
    position: relative
    top: 50%
    transform: translateY(-50%)
  ClearList
    margin-left: 5px
  EditList
    width: 100%
    float: left
    font-size: 20px
  EditContact
    height: 90px
    margin-bottom: 10px
    width: 100%
    background: #FFF
    float: left
    padding: 0 30px 0 20px
  ItemType
    float: right
    color: #888
    position: relative
    top: 50%
    transform: translateY(-50%)
  Item
    float: left
    position: relative
    top: 50%
    transform: translateY(-50%)
  Avatar
    text-align: center
    width: 50px
    height: 50px
    position: relative
    top: 50%
    transform: translateY(50%)
    margin-right: 20px
  Image
    border-radius: 50%
    height: 50px
    width: 50px
    top: 50%
    transform: translateY(50%)
    margin-right: 20px
    position: relative
    float: left
`;

class ResourcesEditList extends Component {
  props: {
    resourcesEditList: Object,
    clearList: Function,
    languagedata: Object,
  }

  render() {
    const { contacts, meetingRooms, otherResources } = this.props.resourcesEditList;

    const contactsList = contacts ? filterNotNullEdgeNodes(contacts) : [];
    // extend contact object with type
    contactsList.map(contact => {
      Object.assign(contact, { type: 'Contact' });
      return contact;
    });
    const meetingRoomsList = meetingRooms ? filterNotNullEdgeNodes(meetingRooms) : [];
    // extend meetingRoom object with type
    meetingRoomsList.map(room => {
      Object.assign(room, { type: 'Meeting room' });
      return room;
    });
    const otherResourcesList = otherResources ? filterNotNullEdgeNodes(otherResources) : [];
    // extend resource object with type
    otherResourcesList.map(resource => {
      Object.assign(resource, { type: 'Other resource' });
      return resource;
    });

    const resourcesList = [...contactsList, ...meetingRoomsList, ...otherResourcesList];

    const resources = resourcesList.map((resource, index) =>
      <div key={index} style={style.EditList} id={resource.id}>
        <div style={style.EditContact}>
          <ContactAvatar
            imagePath={resource.email ? `/contacts/photo/${resource.email}` : null}
            displayName={resource.displayName}
            style={style.Avatar}
            imageStyle={style.Image}
          />
          <span style={style.Item}>{resource.displayName}</span>
          <span style={style.ItemType}>{resource.type}</span>
        </div>
      </div>
    );

    return (
      <div>
        <div style={style.Wrapper}>
          <div style={style.NumberUnits}>
            {resourcesList.length} {this.props.languagedata.units_chosen}
          </div>
          <div style={style.Clear} onClick={this.props.clearList}>
            <i className="fa fa-times" />
            <span style={style.ClearList}>{this.props.languagedata.clear_list}</span>
          </div>
        </div>
        <div style={style.Resources}>
          { resources }
        </div>
      </div>
    );
  }
}

export default Relay.createContainer(ResourcesEditList, {
  initialVariables: {
    showAny: false,
    emails: [null],
  },
  prepareVariables: vars => {
    const showAny = vars.emails[0] !== null ? true : vars.showAny;
    const preparedVars = {
      ...vars,
      showAny,
    };
    return preparedVars;
  },
  fragments: {
    resourcesEditList: () => Relay.QL`
      fragment on Viewer {
        contacts(first: 100000 , emails: $emails) @include(if: $showAny) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        meetingRooms(first: 100000 , emails: $emails) @include(if: $showAny) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        otherResources(first: 100000 , emails: $emails) @include(if: $showAny) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/ResourcesEditList.js